/* eslint-disable no-mixed-operators */
/* eslint-disable radix */
'use strict';
/**
 * @param slider HtmlElement with an initialized slider
 * @param threshold Minimum proximity (in percentages) to merge tooltips
 * @param separator String joining tooltips
 */
 function mergeTooltips(slider, threshold, separator, currencyCode) {
    var textIsRtl = getComputedStyle(slider).direction === 'rtl';
    var isRtl = slider.noUiSlider.options.direction === 'rtl';
    var isVertical = slider.noUiSlider.options.orientation === 'vertical';
    var tooltips = slider.noUiSlider.getTooltips();
    var origins = slider.noUiSlider.getOrigins();

    // Move tooltips into the origin element. The default stylesheet handles this.
    tooltips.forEach(function (tooltip, index) {
        if (tooltip) {
            origins[index].appendChild(tooltip);
        }
    });

    slider.noUiSlider.on('update', function (values, handle, unencoded, tap, positions) {

        var pools = [[]];
        var poolPositions = [[]];
        var poolValues = [[]];
        var atPool = 0;

        // Assign the first tooltip to the first pool, if the tooltip is configured
        if (tooltips[0]) {
            pools[0][0] = 0;
            poolPositions[0][0] = positions[0];
            poolValues[0][0] = values[0];
        }

        for (var i = 1; i < positions.length; i++) {
            if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
                atPool++;
                pools[atPool] = [];
                poolValues[atPool] = [];
                poolPositions[atPool] = [];
            }

            if (tooltips[i]) {
                pools[atPool].push(i);
                poolValues[atPool].push(values[i]);
                poolPositions[atPool].push(positions[i]);
            }
        }

        pools.forEach(function (pool, poolIndex) {
            var handlesInPool = pool.length;

            for (var j = 0; j < handlesInPool; j++) {
                var handleNumber = pool[j];

                if (j === handlesInPool - 1) {
                    var offset = 0;

                    poolPositions[poolIndex].forEach(function (value) {
                        offset += 1000 - value;
                    });

                    var direction = isVertical ? 'bottom' : 'right';
                    var last = isRtl ? 0 : handlesInPool - 1;
                    var lastOffset = 1000 - poolPositions[poolIndex][last];
                    offset = (textIsRtl && !isVertical ? 92 : -8) + (offset / handlesInPool) - lastOffset;
                    // offset = 0 + (offset / handlesInPool) - lastOffset;

                    // Center this tooltip over the affected handles
                    tooltips[handleNumber].innerHTML = currencyCode + poolValues[poolIndex].join(separator);
                    if(poolValues && poolValues[0].length > 1) {
                        offset = offset - 8;
                    }
                    tooltips[handleNumber].style.display = 'block';
                    tooltips[handleNumber].style[direction] = offset + '%';
                } else {
                    // Hide this tooltip
                    tooltips[handleNumber].style.display = 'none';
                }
            }
        });
    });
}


var sortModal = require('../../components/sortModal');
var plc = require('../../components/productListCarousel');
var noUiSlider = require('nouislider');
var wNumb = require('../../components/wNumb');
/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    var rcs = '.mainContainer.category-action-header .categoryname span';
    $(rcs).empty().html($results.find(rcs).html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find(
            '.' + $(this)[0].className.replace(/ /g, '.')
        );
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
    };

    if($results.find('.no-results-page').length > 0) {
        $('.search-page.main-page-content').empty().html(response);
        return;
    }

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.refinement-bar',
        '.sortBar',
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    // update the reset link
    $('.filter-header .reset.btn').attr(
        'data-href',
        $('.filter-header').data('href')
    );
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom
        .find('.grid-footer')
        .data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}
/**
 * Initialize price filter
 */
function initializePriceFilter() {
    var tooltipSlider = document.getElementById('price-slider');
    var minRange = tooltipSlider.dataset.minrange;
    var maxRange = tooltipSlider.dataset.maxrange;
    var minValue = $('#minValue').val();
    var maxValue = $('#maxValue').val();
    var direction = getComputedStyle(tooltipSlider).direction;
    var currencyCode = $('#currencyCode').val();
    
    noUiSlider
        .create(tooltipSlider, {
            start: [minValue, maxValue],
            direction: direction,
            connect: true,
            tooltips: [
                wNumb({ decimals: 2, prefix: currencyCode }),
                wNumb({ decimals: 2, prefix: currencyCode }),
            ],
            range: {
                min: [Math.floor(minRange), 1],
                max: [Math.floor(maxRange), 1],
            },
        })
        .on('update', function (values) {
            var min = values[0];
            var max = values[1];
            $('#minValue').val(min);
            $('#maxValue').val(max);
        });
        mergeTooltips(tooltipSlider, 5, ' - ', currencyCode);
}

/**
 * Initialize page load
 */
function initialize() {
    var checkboxSelected = $('.custom-checkBox.selected');
    checkboxSelected.closest('ul').addClass('show');
    checkboxSelected.closest('li').find('ul').first().addClass('show');
    checkboxSelected.closest('li').siblings('li').addClass('d-none');
    var listContainer = checkboxSelected.closest('li').find('ul');
    if (listContainer.find('li').length) {
        checkboxSelected.closest('li').addClass('show-toggle-button');
        checkboxSelected
            .closest('li')
            .find('.toggle-category')
            .first()
            .addClass('show');
    }

    // parentContainer.parent().parent().find('.custom-checkBox input').first().attr('disabled', true);
    // parentContainer.parent().parent().find('.custom-checkBox .checkmark').first().addClass('d-none');
    // parentContainer.find('ul').addClass('show');
    // parentContainer.find('ul').find('.custom-checkBox').first();
    // parentContainer.find('.toggle-category').first().addClass('show');
    // $('.custom-checkBox.selected').closest('li').siblings('li').addClass('d-none');
}

module.exports = {
    onInit: function () {
        $(function () {
            initialize();
        });
    },
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').addClass('show');
            $('.search-page').addClass('show-overlay');
            $('body').addClass('scroll-lock');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on(
            'click',
            '.refinement-bar button.close, .modal-background',
            function () {
                $('.refinement-bar, .modal-background').removeClass('show');
                $('.search-page').removeClass('show-overlay');
                $('body').removeClass('scroll-lock');
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.row')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.tab-pane.active')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.container.search-results')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.btn.filter-results').focus();
            }
        );
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').removeClass('show');
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document).on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $('.js-sort-modal-wrapper .close').trigger('click');
                    // var eo = plc.getProdSwiper();
                    // if (eo) {
                    //     eo.destroy();
                    // }
                    // plc.mySwiper();
                    $.spinner().stop();
                    module.exports.applyFilter();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    showMore: function () {
        // Show more products
        $(document).on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');

            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document)
            .off('click', '.js-apply-filters')
            .on('click', '.js-apply-filters', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();

                var form = $('#refinementsForm');
                var querystring = form.parents('.page').data('querystring');
                var formURL = form.data('action');
                if (querystring && querystring.length > 0) {
                    var querystringArray = querystring.split('&');
                    for (
                        var index = 0;
                        index < querystringArray.length;
                        index++
                    ) {
                        if (querystringArray[index].indexOf('cgid=') > -1) {
                            querystringArray.splice(index, 1);
                        }
                    }
                    formURL += '?' + querystringArray.join('&');
                }
                var data = {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href'),
                };
                var params = {};

                form.find('input').each(function () {
                    if ($(this).attr('name') === 'cgid') {
                        if ($(this).is(':checked')) {
                            data.cgid = $(this).val();
                        }
                    } else if ($(this).is(':checked')) {
                        if ($(this).attr('name') in params) {
                            params[$(this).attr('name')].push($(this).val());
                        } else {
                            params[$(this).attr('name')] = [$(this).val()];
                        }
                    } else if (
                        $(this).attr('type') !== 'checkbox' &&
                        $(this).attr('type') !== 'radio'
                    ) {
                        if ($(this).attr('name') === 'pmax') {
                            $(this).val(parseInt($(this).val(), 10) + 1);
                        }
                        data[$(this).attr('name')] = $(this).val();
                    }
                });
                var keysArray = Object.keys(params);
                if (keysArray.length) {
                    var i = 0;
                    // eslint-disable-next-line guard-for-in, no-restricted-syntax
                    for (var key in params) {
                        data['prefn' + (i + 1)] = key;
                        data['prefv' + (i + 1)] = params[key].join('|');
                        i++;
                    }
                }
                $.ajax({
                    url: formURL,
                    data: data,
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        // var eo = plc.getProdSwiper();
                        // if (eo) {
                        //     eo.destroy();
                        // }
                        // plc.mySwiper();
                        $.spinner().stop();
                        sortModal.initsortmodal();
                        // if ($(response).find('#minValue').length > 0) {
                        //     initializePriceFilter();
                        // }
                        initialize();
                        $('.refinement-bar button.close').trigger('click');
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });

        $('body').on(
            'click',
            '#refinement-bar-actions .clear-filter',
            function () {
                $.spinner().start();
                $.ajax({
                    url: $(this).data('href'),
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        // var eo = plc.getProdSwiper();
                        // if (eo) {
                        //     eo.destroy();
                        // }
                        // plc.mySwiper();
                        $.spinner().stop();
                        sortModal.initsortmodal();
                        // initializePriceFilter();
                        $('.refinement-bar button.close').trigger('click');
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
            }
        );
    },
    showCategory: function () {
        $('body').on('click', '.category-title', function () {
            var listContainer = $(this).closest('li').find('ul');
            if (listContainer.find('li').length) {
                $(this).closest('li').addClass('show-toggle-button');
                $(this).closest('li').siblings('li').addClass('d-none');
                listContainer.first().addClass('show');
                $(this)
                    .closest('li')
                    .find('.toggle-category')
                    .first()
                    .addClass('show');
            }
        });
    },
    hideCategory: function () {
        $('body').on('click', '.toggle-category', function () {
            var listContainer = $(this).closest('li').find('ul');
            if (listContainer.find('li').length) {
                $(this).closest('li').removeClass('show-toggle-button');
                $(this).closest('li').siblings('li').removeClass('d-none');
                $(this)
                    .closest('li')
                    .find('li')
                    .removeClass('show-toggle-button');
                listContainer.removeClass('show');
                $(this)
                    .closest('li')
                    .find('.toggle-category')
                    .removeClass('show');
            }
        });
    },
    priceFilter: function () {
        /*
        var rangeInput = $('.range-input input');
        var range = $('.slider .progress');
        range.css('left', (rangeInput[0].value / rangeInput[0].max) * 100 + '%');
        range.css('right', 100 - (rangeInput[1].value / rangeInput[1].max) * 100 + '%');
        $('.minSelectedValue').text(rangeInput[0].value);
        $('.maxSelectedValue').text(rangeInput[1].value);
        rangeInput.each(function () {
            $(document).on('change', this, function (e) {
                var minVal = parseInt(rangeInput[0].value);
                var maxVal = parseInt(rangeInput[1].value);

                if (maxVal - minVal < 10) {
                    if (e.target.className === 'range-min') {
                        rangeInput[0].value = maxVal - 10;
                    } else {
                        rangeInput[1].value = minVal + 10;
                    }
                } else {
                    $('.minSelectedValue').text(minVal);
                    $('.maxSelectedValue').text(maxVal);
                    range.css('left', (minVal / rangeInput[0].max) * 100 + '%');
                    range.css('right', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
                }
            });
        });
        */
        // initializePriceFilter();
    },
};
